import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/thesmartcoders/"
        className="home__social-icon"
        target="_blank" rel="noreferrer"
      >
        <i class="uil uil-instagram"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCGxDILuph6ek3L4fwwZR0NA"
        className="home__social-icon"
        target="_blank" rel="noreferrer"
      >
        <i class="uil uil-youtube"></i>
      </a>
      <a
        href="https://github.com/kapilgahlot1998"
        className="home__social-icon"
        target="_blank" rel="noreferrer"
      >
        <i class="uil uil-github"></i>
      </a>
    </div>
  )
}

export default Social
